import { useResource } from '@atlassian/jira-router';
import { boardDetailsResource } from '@atlassian/jira-router-resources-classic-projects';

export const useBoardDetailsData = () => useResource(boardDetailsResource);
